
































































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import ConfirmDialog from "@/shared/ConfirmDialog.vue";
import { findWithAttr } from "@/store/store";
import { IStore, IFetchRequest, IFetchResult } from "../api/store.interface";
import { ICompany } from "@/features/companies/api/company.interface";
import {
  StoreEventBus,
  GET_STORES,
  ADD_EDIT_STORE
} from "@/features/stores/api/store.event";

@Component({
  name: "storeTable",
  components: {
    ConfirmDialog
  }
})
export default class StoreTable extends Vue {
  // Lifecycle Functions

  mounted(): void {
    StoreEventBus.$on(GET_STORES, () => {
      this.getStores();
    });
  }

  // Getters

  @Getter("store/stores")
  stores: IStore[];
  @Getter("salesReceipt/salesReceipts")
  salesReceipts: any;
  @Getter("store/fetchResults")
  fetchResults: IFetchResult[];
  @Getter("company/companies")
  companies: ICompany[];
  @Getter("auth/authStatus")
  authStatus: string;

  // Computed
  get calAttributes(): any {
    return this.selectedReceipts.map(s => ({
      key: `salesReceipt.${s.id}`,
      highlight: {
        backgroundColor:
          s.cash.txnId != null && s.charge.txnId != null
            ? "lightGreen"
            : s.cash.failed || s.charge.failed
            ? "red"
            : "orange"
      },
      dates: s.date,
      customData: s
    }));
  }

  // References
  $refs: {
    confirm: any;
  };

  // Locals

  selectedDay: any = {};
  selectedReceipts: any[] = [];

  loading: boolean = false;

  headers: any[] = [
    {
      text: "Store",
      align: "left",
      sortable: true,
      value: "storeId"
    },
    {
      text: "Username",
      align: "center",
      sortable: "false",
      value: "storeUsername"
    },
    {
      text: "Cash Account",
      align: "center",
      sortable: "true",
      value: "cashAccountRef"
    },
    {
      text: "Charge Account",
      align: "center",
      sortable: "true",
      value: "creditAccountRef"
    },
    {
      text: "Company",
      align: "center",
      sortable: "true",
      value: "company"
    },
    {
      text: "Start Date",
      align: "center",
      sortable: "true",
      value: "startDate"
    },
    {
      text: "Auto Update",
      align: "center",
      sortable: "false",
      value: "autoUpdate"
    },
    {
      text: "Sales Receipts",
      align: "center",
      sortable: false,
      value: "storeId"
    },
    {
      text: "Actions",
      align: "center",
      sortable: false,
      value: "storeId"
    }
  ];

  getStores(): void {
    this.loading = true;
    var self = this;
    this.$store
      .dispatch("store/getAll")
      .then(() => {
        self.loading = false;
        self.getReceipts();
      })
      .catch(() => {
        self.loading = false;
      });
  }

  getReceipts(): void {
    this.stores.forEach(store => {
      this.$store.dispatch("salesReceipt/getForStore", store.id);
    });
  }

  expand(props: any) {
    this.selectedDay = {};
    this.selectedReceipts = this.salesReceipts[props.item.id];
    props.expanded = !props.expanded;
  }

  dayClicked(day: any, id: number): void {
    this.selectedDay = day;
  }

  deleteStore(store: IStore): void {
    this.$refs.confirm
      .open(
        "Are you sure?",
        "Deleting this store will also delete all associated data and cannot be reversed.",
        {
          color: "red"
        }
      )
      .then((confirm: boolean) => {
        if (confirm) {
          this.$store.dispatch("store/delete", store.id);
        }
      });
  }

  editStore(store: IStore) {
    StoreEventBus.$emit(ADD_EDIT_STORE, store);
  }

  showReceipts(store: IStore): void {
    this.$router.push({
      name: "salesReceipts",
      query: { storeId: store.id.toString(), storeName: store.storeId }
    });
  }

  // Helper functions

  companyFromId(id: number): string {
    var company: ICompany[] = this.companies.filter((obj: ICompany) => {
      return obj.id === id;
    });

    if (company.length > 0) return company[0].name;

    return "";
  }

  isEmpty(str: string): boolean {
    return !str || 0 === str.length;
  }
}
